import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { SHORTCUT_LIST } from '@/hooks/useKeyboardShortcuts';
import { Keyboard } from 'lucide-react';

export function ShortcutsHelp({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Keyboard className="w-5 h-5 text-blue-600" />
            Atalhos de Teclado
          </DialogTitle>
        </DialogHeader>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 py-4">
          {SHORTCUT_LIST.map((group) => (
            <div key={group.category}>
              <h3 className="text-sm font-semibold text-slate-900 mb-3 pb-2 border-b">
                {group.category}
              </h3>
              <div className="space-y-2">
                {group.shortcuts.map((shortcut) => (
                  <div key={shortcut.keys} className="flex items-center justify-between">
                    <span className="text-sm text-slate-600">{shortcut.action}</span>
                    <kbd className="px-2 py-1 text-xs font-mono bg-slate-100 border border-slate-200 rounded">
                      {shortcut.keys}
                    </kbd>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <h4 className="text-sm font-semibold text-blue-900 mb-2">💡 Dicas</h4>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>• Use <kbd className="px-1 bg-white rounded border text-xs">Ctrl + K</kbd> para busca rápida</li>
            <li>• Adicione páginas aos favoritos clicando na ⭐</li>
            <li>• Os atalhos funcionam em qualquer página</li>
            <li>• Pressione <kbd className="px-1 bg-white rounded border text-xs">Esc</kbd> para fechar modais</li>
          </ul>
        </div>
      </DialogContent>
    </Dialog>
  );
}
